import { Group, Radio, Stack, Text } from "@mantine/core";

import type { CallbackFormVariant, CallbackRadioOption } from "../../types";

import { useCallbacksFormStore } from "../../callbacksForm.store";
import { SecondsInput } from "./Inputs";

interface CallbackTypeSelectionProps {
    value: CallbackRadioOption | undefined;
    variant: CallbackFormVariant;
}

/** options to show during a session with an active ongoing call*/
export function ActiveCallOptions() {
    return (
        <Group gap="xs">
            <SecondsInput />
            <Text size="xs">seconds</Text>
        </Group>
    );
}

/** options to show during the wrap-up/session-summary phase of a session */
function PostCallOptions({ value }: { value: CallbackTypeSelectionProps["value"] }) {
    const { setCallbackType } = useCallbacksFormStore();
    return (
        <Radio.Group ml="sm" onChange={(v) => setCallbackType(v as CallbackRadioOption)} value={value}>
            <Radio mb="sm" label="now" fw="lighter" fs="sm" value="callback-user-now" />
            <Radio
                label={
                    <Group gap="xs">
                        in
                        <SecondsInput disabled={value !== "callback-user-with-delay"} />
                    </Group>
                }
                fw="lighter"
                fs="sm"
                value="callback-user-with-delay"
            />
        </Radio.Group>
    );
}

/** Radio group selection component for handling callback options*/
export function CallbackTypeSelection({ value, variant = "active-call" }: CallbackTypeSelectionProps) {
    const renderOptions = () => (variant === "active-call" ? <ActiveCallOptions /> : <PostCallOptions value={value} />);

    return <Stack gap="lg">{renderOptions()}</Stack>;
}
